import { useState } from 'react'
import { FiPlus } from 'react-icons/fi'

import ChatHeader from '@/components/ChatHeader'

const SKILLS = [
  {
    id: 1,
    title: '全能写作助手',
    desc: '提供多种文案创作选择，轻松完成各种文案任务。',
    usage: '1277.9万人聊过',
    icon: '✏️',
    bgColor: 'bg-yellow-100',
    category: '工作'
  },
  {
    id: 2,
    title: '识图生成提示词',
    desc: '上传图片，根据图片内容精准生成提示词，帮助...',
    usage: '12.8万人聊过',
    icon: '🖼️',
    bgColor: 'bg-blue-100',
    category: '创作'
  },
  {
    id: 3,
    title: '英文写作润色',
    desc: 'An assistant dedicated to polishing English wri...',
    usage: '23.6万人聊过',
    icon: 'AI',
    bgColor: 'bg-yellow-50',
    category: '学习'
  },
  {
    id: 4,
    title: '小红书文案创作',
    desc: '能为您创作自然活泼简短小红书文案并加相关标签',
    usage: '77.9万人聊过',
    icon: '📕',
    bgColor: 'bg-red-100',
    category: '创作'
  },
  {
    id: 5,
    title: '高情商回复',
    desc: '聊天时不知道怎么回复，就来帮你~',
    usage: '11.8万人聊过',
    icon: '💬',
    bgColor: 'bg-pink-100',
    category: '生活'
  },
  {
    id: 6,
    title: '中英翻译',
    desc: '专业翻译助手，精准转换中英内容，专注翻译不...',
    usage: '35.1万人聊过',
    icon: 'A',
    bgColor: 'bg-gray-100',
    category: '工作'
  },
  {
    id: 7,
    title: 'EXCEL大全',
    desc: '拥有卓越数据处理能力，助您解决 Excel 各类难...',
    usage: '44.9万人聊过',
    icon: '📊',
    bgColor: 'bg-blue-50',
    category: '工作'
  },
  {
    id: 8,
    title: '论文助手',
    desc: '能助力用户完成严谨详实论文的专业助手',
    usage: '106.8万人聊过',
    icon: '📄',
    bgColor: 'bg-gray-100',
    category: '学习'
  }
]

const TABS = ['学习', '创作', '工作', '生活']

export default function ChatBotDiscover() {
  const [activeTab, setActiveTab] = useState('工作')

  const filteredSkills = SKILLS.filter((skill) => skill.category === activeTab)

  return (
    <div className="flex flex-1 flex-col overflow-hidden bg-white transition-all duration-300">
      <ChatHeader showTitle={false} showResourcePreview={false} />

      <div className="flex-1 overflow-y-auto">
        <div className="mx-auto w-full max-w-5xl px-4 py-6 md:px-8 md:py-8">
          {/* Tabs */}
          <div className="mb-6 flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
            {TABS.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`whitespace-nowrap rounded-full px-6 py-2 text-sm font-medium transition-colors ${
                  activeTab === tab ? 'bg-blue-600 text-white' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Skills Grid */}
          <div className="grid grid-cols-1 gap-4 desktop:grid-cols-2">
            {filteredSkills.map((skill) => (
              <div key={skill.id} className="group flex cursor-pointer items-start gap-4 rounded-2xl border border-gray-100 p-4 transition-all hover:border-blue-100 hover:shadow-sm">
                <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-2xl ${skill.bgColor}`}>{skill.icon}</div>
                <div className="flex flex-1 flex-col justify-center overflow-hidden">
                  <h3 className="mb-1 truncate text-base font-medium text-gray-900">{skill.title}</h3>
                  <p className="mb-2 line-clamp-1 text-sm text-gray-500">{skill.desc}</p>
                  <div className="flex items-center gap-1 text-xs text-gray-400">
                    <span className="flex h-3 w-3 items-center justify-center rounded-full bg-gray-200 text-[8px] text-white">🔥</span>
                    {skill.usage}
                  </div>
                </div>
                <button className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-gray-400 opacity-0 transition-all group-hover:bg-blue-50 group-hover:text-blue-600 group-hover:opacity-100 md:opacity-100">
                  <FiPlus className="h-5 w-5" />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
